var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ep-tabs_w-full"},[_c('div',{staticClass:"ep-tabs__header ep-tabs__row"},[_c('div',{class:_vm.classes},[_vm._t("tabs",null,{"callback":_vm.selectTab})],2),_vm._t("extend")],2),_vm._t("tab")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }